import { TimeSpan } from "@sparkware/app-utils";
import {IRealityCheckHandler} from "./reality-check-handler.interface";

export class VoidRealityCheckHandler implements IRealityCheckHandler {
    async getBusinessCorrelationId(): Promise<string> {
        return "";
    }

    async sendUniqueAnalyticsEvent(eventKey: string, sendEvent: (businessCorrelationId: string) => Promise<void>): Promise<void> {

    }

    async handleRealityCheck(sessionTimer: TimeSpan): Promise<void> {

    }

    dispose(): void {

    }
}